import * as React from "react";
import { IconProps } from "../types";

const EyeSlashOutlineIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="18"
        height="18"
        fill="none"
        viewBox="0 0 18 18"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
        {...props}
      >
        <path
          d="M14.938 6.597C15.339 7.047 15.663 7.488 15.912 7.867C16.362 8.55 16.362 9.449 15.912 10.132C14.894 11.675 12.65 14.25 9 14.25C8.451 14.25 7.934 14.192 7.448 14.088"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.95599 13.044C3.59999 12.168 2.65399 10.991 2.08799 10.132C1.63799 9.44899 1.63799 8.54999 2.08799 7.86699C3.10599 6.32399 5.34999 3.74899 8.99999 3.74899C10.62 3.74899 11.963 4.25599 13.044 4.95499"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.579 9.95599C11.301 10.706 10.706 11.301 9.95599 11.579"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.055 10.945C6.557 10.447 6.25 9.76 6.25 9C6.25 7.481 7.481 6.25 9 6.25C9.759 6.25 10.447 6.558 10.945 7.055"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2 16L16 2"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);

export default EyeSlashOutlineIcon;
